// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    position: relative;
    display: inline-block;
    --arrow-offset: 20px;
    /*width: -webkit-fill-available;*/
}
/*:host([kind="info"]) img {*/
/*    content: url("src/foundations/icons/circle-info.svg");*/
/*    display: inline-block;*/
/*    width: 14px;*/
/*    height: 14px;*/
/*}*/


.swiftref-tooltip {
    background: var(--background-inverse);
    color: var(--text-ondark);
    pointer-events: none;
    position: absolute;
    padding: var(--spacing-10);
    z-index: 2;
    min-width: var(--spacing-100);
    border-radius: var(--spacing-05);
    font-family: var(--caption-regular-font-family), sans-serif;
    font-size: var(--caption-regular-font-size);
    letter-spacing: var(--caption-regular-letter-spacing);
    line-height: var(--caption-regular-line-height);
    font-weight: var(--caption-regular-font-weight);
    align-items: center;
    display: flex;
    visibility: hidden;
    width: max-content;
    max-width: 360px;
    flex-wrap: wrap;
    word-break: break-word;
    text-align: left;
    /*bottom: unset !important;*/
}
.swiftref-tooltip.active {
    display: flex;
    visibility: visible;
}
.swiftref-tooltip:after {
    content: "";
    position: absolute;
    left: var(--arrow-offset);
    top: 100%;
    width: 0;
    height: 0;
    margin-left: -10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--background-inverse);
}

.swiftref-tooltip.bottom:after {
    top: -10px;
    transform: rotate(180deg);
}
.swiftref-tooltip > div {
    display: block !important;
}

@media (max-width: 940px) {
    .swiftref-tooltip {
        max-width: 50vw;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/tooltip/style/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,iCAAiC;AACrC;AACA,6BAA6B;AAC7B,6DAA6D;AAC7D,6BAA6B;AAC7B,mBAAmB;AACnB,oBAAoB;AACpB,IAAI;;;AAGJ;IACI,qCAAqC;IACrC,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,UAAU;IACV,6BAA6B;IAC7B,gCAAgC;IAChC,2DAA2D;IAC3D,2CAA2C;IAC3C,qDAAqD;IACrD,+CAA+C;IAC/C,+CAA+C;IAC/C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,oCAAoC;IACpC,gDAAgD;AACpD;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[":host {\n    position: relative;\n    display: inline-block;\n    --arrow-offset: 20px;\n    /*width: -webkit-fill-available;*/\n}\n/*:host([kind=\"info\"]) img {*/\n/*    content: url(\"src/foundations/icons/circle-info.svg\");*/\n/*    display: inline-block;*/\n/*    width: 14px;*/\n/*    height: 14px;*/\n/*}*/\n\n\n.swiftref-tooltip {\n    background: var(--background-inverse);\n    color: var(--text-ondark);\n    pointer-events: none;\n    position: absolute;\n    padding: var(--spacing-10);\n    z-index: 2;\n    min-width: var(--spacing-100);\n    border-radius: var(--spacing-05);\n    font-family: var(--caption-regular-font-family), sans-serif;\n    font-size: var(--caption-regular-font-size);\n    letter-spacing: var(--caption-regular-letter-spacing);\n    line-height: var(--caption-regular-line-height);\n    font-weight: var(--caption-regular-font-weight);\n    align-items: center;\n    display: flex;\n    visibility: hidden;\n    width: max-content;\n    max-width: 360px;\n    flex-wrap: wrap;\n    word-break: break-word;\n    text-align: left;\n    /*bottom: unset !important;*/\n}\n.swiftref-tooltip.active {\n    display: flex;\n    visibility: visible;\n}\n.swiftref-tooltip:after {\n    content: \"\";\n    position: absolute;\n    left: var(--arrow-offset);\n    top: 100%;\n    width: 0;\n    height: 0;\n    margin-left: -10px;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid var(--background-inverse);\n}\n\n.swiftref-tooltip.bottom:after {\n    top: -10px;\n    transform: rotate(180deg);\n}\n.swiftref-tooltip > div {\n    display: block !important;\n}\n\n@media (max-width: 940px) {\n    .swiftref-tooltip {\n        max-width: 50vw;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
